import { ConfluenceScope } from './types';

export const defaultPermissionsSupplier = () => {
	const response = Object.values(ConfluenceScope);
	return Promise.resolve(response);
};
